import React from 'react'

import { CardBody, Collapse } from 'reactstrap'

import cx from 'classnames'

export default ({ children, bodyClassName, isBodyOpen }) => {
  return (
    <Collapse isOpen={isBodyOpen} className={cx(bodyClassName)}>
      <CardBody>{children}</CardBody>
    </Collapse>
  )
}
